import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const vocabularyGroupTaxonomiesManifest: FeatureManifest = {
  id: 'english-knowledge-vocabulary-group-taxonomies',
  path: 'english-knowledge/vocabulary-groups/taxonomies/*',
  navPath: '/english-knowledge/vocabulary-groups/taxonomies',
  label: 'Phân loại',
  description: 'Quản lý chủ đề dùng để phân loại nhóm từ vựng',
  navigationGroup: { id: 'vocabulary-groups', label: 'Nhóm từ vựng' },
  load: () => import('./entry'),
}
